import { lazy, Suspense, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import LoginScreen from "../screens/Auth/LoginScreen";
import SelectProjectModal from "../screens/SelectProjectModal";
import FullScreenLoader from "../shared/loader/FullScreenLoader";
const AdminApplication = lazy(() => import("./AdminApplication"));
// const LoginScreen = lazy(() => import("../screens/Auth/LoginScreen"));

const MachinesStatusApplication = lazy(() =>
  import("./MachinesStatusApplication")
);

function StartUpScreen() {
  const dispatch = useDispatch();
  const authData = useSelector((state) => state?.authData);
  const [selectUnitModal, setSelectUnitModal] = useState(false);
  const userInfo = JSON.parse(localStorage.getItem("userInfo"));
  const selectedProject = localStorage.getItem("selectedProject");

  useEffect(() => {
    setSelectUnitModal(true);
  }, []);

  if (userInfo && selectedProject == null) {
    return (
      <Suspense fallback={<FullScreenLoader />}>
        <SelectProjectModal setShowModal={setSelectUnitModal} />
      </Suspense>
    );
  }

  if (userInfo && selectedProject === "ecoMetrix") {
    // setSelectUnitModal(false);
    return (
      <Suspense fallback={<FullScreenLoader />}>
        <AdminApplication />
      </Suspense>
    );
  }
  if (userInfo && selectedProject === "machineStatus") {
    // setSelectUnitModal(false);
    return (
      <Suspense fallback={<FullScreenLoader />}>
        <MachinesStatusApplication />
      </Suspense>
    );
  }

  return (
    // <Suspense
    //   fallback={
    //     <div className="flex justify-center items-center h-screen w-screen bg-[#262932]">
    //       <img src="/pxLogo.png" alt="loginLogo" className="w-[20%]" />
    //     </div>
    //   }
    // >
    //   <LoginScreen />
    // </Suspense>
    <LoginScreen />
  );
}
export default StartUpScreen;
